/**
 * Left-column "About" card, styled after the transcoder harness. The file loader
 * and drag-and-drop live in DropPanel; this is just the descriptive copy.
 */
export function AboutPanel() {
  return (
    <div className="asset">
      <div className="asset-hd">
        <span className="asset-title">About</span>
      </div>
      <div className="about">
        <p>
          <b>Plane Finder</b> finds flat surfaces in a 3D model and captures them
          perfectly head-on.
        </p>
        <p>
          Drop in a glb and tap a flat area. <b>Flatness</b> sets how strictly the
          selection sticks to flat geometry — lower it to grow over bumps and
          curves. <b>Cull</b> hides geometry in front of and behind the surface.
        </p>
        <p className="about-made">
          Made by{' '}
          <a href="https://eyejack.io" target="_blank" rel="noopener noreferrer">
            EyeJack
          </a>
          <br />
          Try our WebAR platform{' '}
          <a href="https://creator.eyejack.io" target="_blank" rel="noopener noreferrer">
            EyeJack Creator
          </a>
        </p>
      </div>
    </div>
  );
}
